import { inject, Injectable } from "@angular/core";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";
import { Fee } from "@modules/main/components/step-summary/sending-modal/entities/fee.model";
import { SendTransaction } from "@models/transaction";

@Injectable({
	providedIn: "root"
})
export class MultichainContactsRemote {
	private readonly apiService: ApicallService = inject(ApicallService);

	public validateContactAndGetFee(walletId: string, transaction: SendTransaction): Observable<Fee> {
		return this.apiService.post("wallet/" + walletId + "/send/validate", new ApicallOption(Fee, transaction)).pipe(
			map((fees: Fee[]) => fees[0]),
			filter((fee: Fee) => Boolean(fee))
		);
	}
}
